export class UserAnalyticsRepository {
}
//# sourceMappingURL=UserAnalyticsRepository.js.map